import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

interface SectionProps {
  title?: string;
  description?: string;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
}

/** A titled content section with an <h2> heading and optional actions. */
export function Section({ title, description, actions, children, className }: SectionProps) {
  const hasHeader = Boolean(title) || Boolean(actions) || Boolean(description);

  return (
    <section className={cn('flex flex-col gap-4', className)}>
      {hasHeader && (
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div className="space-y-1">
            {title && <h2 className="text-lg font-semibold tracking-tight">{title}</h2>}
            {description && <p className="text-muted-foreground text-sm">{description}</p>}
          </div>
          {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
        </div>
      )}
      {children}
    </section>
  );
}
